import Bugsnag from "@bugsnag/js";
import {
  changeSimEsimOrchestrator,
  mobileOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { client } from "@nju/http-client";
import { BasicError, err } from "@nju/result";
import { ISetSimCardResult } from "./types";
import { setSimCardErrorResponse } from "./validators";

const modeToOrchestratorMap = {
  mobile: mobileOrchestrator,
  changeSimEsim: changeSimEsimOrchestrator,
} as const;

interface ISetSimCard {
  mode: "mobile" | "changeSimEsim";
  orchestratorId: string;
  simOrIccId: string;
}

export async function setSimCard({
  mode,
  simOrIccId,
  orchestratorId,
}: ISetSimCard): Promise<ISetSimCardResult> {
  const serverResponse = modeToOrchestratorMap[mode];

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/SIM_SET`,
    {
      method: "post",
      validator: serverResponse,
      json: {
        ...(simOrIccId.length === 4 && { code: simOrIccId }),
        ...(simOrIccId.length === 19 && { iccid: simOrIccId }),
      },
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    const errorInfo = setSimCardErrorResponse.safeParse(result.err.extra?.json);

    if (errorInfo.success && errorInfo.data.code === "50189") {
      return err(
        new BasicError({
          message: "wrong sim code",
          code: "WRONG_SIM_CODE",
        }),
      );
    }

    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
